import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const CarouselContainer = styled.div`
    padding: 32px;
    width: 100%;

    @media(max-width: ${wideBreakpoints.mobile}) {
        padding: 24px;
    }
`;

export const ContentContainer = styled(IndentContainer)`
    background: ${COLORS.BgMain};

    &:last-child {
        margin-bottom: 84px;
    }
`;

export const RoundedContainer = styled(ContentContainer)`
    border-top-left-radius: ${BorderRadius.OuterBlockRadius};
    border-top-right-radius: ${BorderRadius.OuterBlockRadius};
`;

export const Footer = styled.div`
    position: absolute;
    bottom: 0;
    background: ${COLORS.BgSubstrate};
    width: 100%;
    border-top: 1.5px  solid ${COLORS.Outline_Light};
    
    @media(max-width: ${wideBreakpoints.mobile}) {
        ${Button}[data-bType='accent']{
            width: 100%;
        }
    }
`;
